// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090016/js/" + chunkId + "." + {"44":"e094b908","225":"655c9687","481":"57243f32","486":"b9372d9c","770":"4d79740a"}[chunkId] + ".0.7982599928292864.chunk.js";
};